import React from "react";
import API from "../utils/API.js";
import { Route, Redirect } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route key={`private-component-${Component.key}` }
        {...rest}
        render={(props) => {
            if (API.isAuth() === false) {
                return <Redirect to="/" />;
            } else {
                return <Component {...props} key={props.key}/>;
            }
        }}
    />
);